import { call, takeLatest } from "redux-saga/effects";
import actionTypes from "../../actions/actionTypes";
import { getRoutesDataCall } from "../../apis/wpApi/apiCalls";
import authUser from "../../apis/wpApi/authUser";
import { putError, putSuccess } from "../helpers";


function* getData({payload}) {
    try {
        const apiKey = yield call(authUser.getToken)
        const response = yield call(getRoutesDataCall, apiKey, payload.signal)

        yield putSuccess(actionTypes.WP_ROUTES_DATA_GET_SUCCESS, response.data)
    } catch(e) {
        yield putError(actionTypes.WP_ROUTES_DATA_GET_ERROR, e.message)
    }
}


function* routesDataSaga() {
    yield takeLatest(actionTypes.WP_ROUTES_DATA_GET_REQUEST, getData)
}

export default routesDataSaga;